import { Edit, Plus, Search, Trash2 } from "lucide-react";
import { Badge } from "../../tailwind/badge";
import { Button } from "../../tailwind/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../tailwind/dialog";
import { CONTACTS_PRIMARY_BUTTON_CLASS } from "../../../pages/whatsapp/data/contactsData";
import { Input } from "../../tailwind/input";

export default function AttributeLibraryDialog({ open, onOpenChange, attributes }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[85vh] overflow-y-auto bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800">
        <DialogHeader>
          <DialogTitle>Attribute Library</DialogTitle>
          <DialogDescription>
            Define custom attributes once, use them consistently across all your contacts and
            workflows.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <div className="flex items-center justify-between gap-3">
            <div className="relative flex-1 max-w-sm">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400 dark:text-gray-500" />
              <Input
                placeholder="Search attributes..."
                className="pl-9 h-9 text-sm bg-white dark:bg-slate-950 border-gray-200 dark:border-slate-800"
              />
            </div>
            <Button size="sm" className={`h-9 ${CONTACTS_PRIMARY_BUTTON_CLASS}`}>
              <Plus className="h-4 w-4 mr-2" />
              New Attribute
            </Button>
          </div>

          <div className="border border-gray-200 dark:border-slate-800 rounded-xl overflow-hidden">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-50 dark:bg-slate-950 border-b border-gray-200 dark:border-slate-800 text-gray-500 dark:text-gray-400 text-xs uppercase font-medium">
                <tr>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Type</th>
                  <th className="px-4 py-3">Description</th>
                  <th className="px-4 py-3 text-right">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-slate-800">
                {attributes.map((attribute) => (
                  <tr key={attribute.id} className="hover:bg-gray-50/50 dark:hover:bg-slate-800/50">
                    <td className="px-4 py-3 font-medium text-gray-900 dark:text-white">
                      {attribute.name}
                    </td>
                    <td className="px-4 py-3">
                      <Badge
                        variant="outline"
                        className="font-normal text-xs bg-gray-50 dark:bg-slate-800 text-gray-600 dark:text-gray-300"
                      >
                        {attribute.type}
                      </Badge>
                    </td>
                    <td className="px-4 py-3 text-gray-500 dark:text-gray-400 truncate max-w-[200px]">
                      {attribute.description}
                    </td>
                    <td className="px-4 py-3 text-right">
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-8 w-8 p-0 text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400"
                      >
                        <Edit className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-8 w-8 p-0 text-gray-400 hover:text-red-600 dark:hover:text-red-400"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
